import actions from '../action/installment'
import CONSTANT from '../constant/installment'

export default {
  actions,
  state: {

  },
  getters: {

  },
  mutations: {
    [CONSTANT.INSTALLMENT_GETINSTALLMENTBANKS_SUCCESS](state, data) {

    },
    [CONSTANT.INSTALLMENT_GETINSTALLMENTBANKS_ERROR](state, e) {},
    [CONSTANT.INSTALLMENT_GETINSTALLMENTPAYPERIODS_SUCCESS](state, data) {

    },
    [CONSTANT.INSTALLMENT_GETINSTALLMENTPAYPERIODS_ERROR](state, e) {

    },
    [CONSTANT.INSTALLMENT_SENDPAYSMS_SUCCESS](state, data) {

    },
    [CONSTANT.INSTALLMENT_SENDPAYSMS_ERROR](state, e) {

    },
    [CONSTANT.INSTALLMENT_COMMITINSTALLMENT_SUCCESS](state, data) {

    },
    [CONSTANT.INSTALLMENT_COMMITINSTALLMENT_ERROR](state, e) {

    },
    [CONSTANT.INSTALLMENT_CHECKISBANKCARDSUPPORT_SUCCESS](state, data) {

    },
    [CONSTANT.INSTALLMENT_CHECKISBANKCARDSUPPORT_ERROR](state, e) {

    },
    [CONSTANT.INSTALLMENT_OPENBANKCARDPAYMENT_SUCCESS](state, data) {

    },
    [CONSTANT.INSTALLMENT_OPENBANKCARDPAYMENT_ERROR](state, e) {

    },
    [CONSTANT.INSTALLMENT_SENDSMSFOROPENPAY_SUCCESS](state, data) {

    },
    [CONSTANT.INSTALLMENT_SENDSMSFOROPENPAY_ERROR](state, e) {

    },
    [CONSTANT.INSTALLMENT_TOOPENPAY_SUCCESS](state, data) {

    },
    [CONSTANT.INSTALLMENT_TOOPENPAY_ERROR](state, e) {

    },
    [CONSTANT.INSTALLMENT_CHECKPAYRESULT_SUCCESS] (state, data) {

    },
    [CONSTANT.INSTALLMENT_CHECKPAYRESULT_ERROR] (state, e) {

    },
    /*yeoman-template-point-1*/
  }
}
